<script setup lang="ts">
/* Rendered for any unmatched path, signed in or not. */
import { computed } from 'vue'
import Button from '@/components/ui/Button.vue'
import Logo from '@/components/Logo.vue'
import { HOME_ROUTE, routes } from '@/config/routes'
import { useAuth } from '@/lib/auth/useAuth'
import { useDocumentTitle } from '@/lib/composables/useDocumentTitle'

useDocumentTitle('Page not found')

const { status } = useAuth()
const signedIn = computed(() => status.value === 'authenticated')
</script>

<template>
  <div class="wrap">
    <Logo :size="40" />
    <p class="code">404</p>
    <h1 class="title">This page does not exist</h1>
    <p class="text">
      The link may be out of date, or the page may have moved since it was shared with you.
    </p>
    <Button :to="signedIn ? HOME_ROUTE : routes.signIn" icon="arrowRight">
      {{ signedIn ? 'Back to dashboard' : 'Go to sign in' }}
    </Button>
  </div>
</template>

<style scoped>
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2xs);
  min-height: 100dvh;
  padding: var(--space-lg);
  text-align: center;
  background-color: var(--color-bg);
}

.code {
  margin-top: var(--space-md);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  letter-spacing: var(--tracking-caps);
  color: var(--color-accent);
}

.title {
  font-size: var(--text-xl);
}

.text {
  max-width: 44ch;
  margin-bottom: var(--space-sm);
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
</style>
